// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3itaF","label":"Section_label__2Lvpa","contentWrap":"Section_contentWrap__1Gyya","footer":"Section_footer__3252u","footerInner":"Section_footerInner__9KAdz"};